module.exports = __webpack_public_path__ + "img/productView4.547e317a.png";